/**
 * EsqueciSenhaPage.js
 *
 * Trim de hay-hotspot/assets/reactweb/src/pages/Login/EsqueciSenhaPage.js (Fase 1.6) — removida
 * a etapa de escolha de canal (`canal` email/sms): o LinkInsight só tem e-mail (ver
 * `Usuario.esqueciSenha*`, Fase 1.4). Fluxo: identificar -> otp (enviado automaticamente por
 * e-mail) -> nova senha -> sucesso.
 */
import React, { Component } from 'react';
import lodash from 'lodash';

import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Divider } from 'primereact/divider';

import { ModelTextInput } from 'hay-core-react';
import { ModelSenha } from 'hay-core-react';
import { ModelOtp } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import LogoInicial from '../../images/LogoInicial.png';
import { withRouter } from 'hay-core-react';

class EsqueciSenhaPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      etapa: 'identificar',
      model: {
        identificador: {
          value: '',
          erro: '',
          exibir: 'main.esquecisenha.identificador',
          validacao: { obrigatorio: true },
        },
      },
      destino: '',
      tamanhoPin: 4,
      erroGeral: '',
      carregando: false,
    };
  }

  traduzir(chave) {
    return UtilService.traduzir(chave);
  }

  traduzirModel(model) {
    return this.traduzir(model.exibir);
  }

  traduzirHelp() {
    return '';
  }

  getRenderer() {
    return null;
  }

  updateModelPath(path, valor) {
    this.setState(prevState => {
      const obj = lodash.cloneDeep(prevState.model);
      lodash.set(obj, path, valor);
      return { model: obj };
    });
  }

  async avancarIdentificar() {
    const model = UtilService.validarEsquema(this.state.model);
    this.setState({ model, erroGeral: '' });
    if (!model.valido) return;

    this.setState({ carregando: true });
    const identificador = model.identificador.value.trim();
    const result = await ApiService.esqueciSenhaIdentificar(identificador);

    if (!result?.status) {
      this.setState({ carregando: false, erroGeral: this.traduzir(result?.data?.state) || result?.data?.message });
      return;
    }

    this.setState({ destino: result.data.destino || '' });
    await this.enviarOtp();
  }

  async enviarOtp() {
    this.setState({ carregando: true });
    const identificador = this.state.model.identificador.value.trim();
    const result = await ApiService.esqueciSenhaEnviarOtp(identificador);

    if (result?.status) {
      this.setState(prevState => ({
        carregando: false,
        etapa: 'otp',
        erroGeral: '',
        model: {
          ...prevState.model,
          codigo: {
            value: '',
            erro: '',
            exibir: 'main.esquecisenha.codigo',
            validacao: { obrigatorio: true },
          },
        },
      }));
    } else {
      this.setState({ carregando: false, erroGeral: this.traduzir(result?.data?.state) || result?.data?.message });
    }
  }

  async avancarOtp() {
    const model = UtilService.validarEsquema(this.state.model);
    this.setState({ model, erroGeral: '' });
    if (!model.valido) return;

    this.setState({ carregando: true });
    const identificador = model.identificador.value.trim();
    const result = await ApiService.esqueciSenhaConfirmarOtp(identificador, model.codigo.value);

    if (result?.status) {
      this.setState(prevState => ({
        carregando: false,
        etapa: 'novaSenha',
        model: {
          ...prevState.model,
          novasenha: {
            value: '',
            erro: '',
            exibir: 'main.esquecisenha.novasenha',
            validacao: { obrigatorio: true, tamanhominimo: 6 },
          },
          novasenhaconf: {
            value: '',
            erro: '',
            exibir: 'main.esquecisenha.novasenhaconf',
            validacao: { obrigatorio: true, identico: { campo: 'novasenha', descricao: 'Nova Senha' } },
          },
        },
      }));
    } else {
      this.setState({ carregando: false, erroGeral: this.traduzir(result?.data?.state) || result?.data?.message });
    }
  }

  async salvarNovaSenha() {
    const model = UtilService.validarEsquema(this.state.model);
    this.setState({ model, erroGeral: '' });
    if (!model.valido) return;

    this.setState({ carregando: true });
    const identificador = model.identificador.value.trim();
    const result = await ApiService.esqueciSenhaRedefinir(identificador, model.codigo.value, model.novasenha.value, model.novasenhaconf.value);

    if (result?.status) {
      this.setState({ carregando: false, etapa: 'sucesso', erroGeral: '' });
    } else {
      this.setState({ carregando: false, erroGeral: this.traduzir(result?.data?.state) || result?.data?.message });
    }
  }

  handleKeyDown(e, acao) {
    if (e.key === 'Enter') acao();
  }

  render() {
    const { model, etapa, destino, tamanhoPin, erroGeral, carregando } = this.state;

    return (
      <div className="min-h-screen flex align-items-center justify-content-center surface-ground px-3 py-3 ">
        <div
          className="surface-card border-round-2xl shadow-4 w-full p-5 md:p-6"
          style={{ maxWidth: '440px' }}
        >
          <div className="flex flex-column align-items-center mb-5">
            <img
              src={LogoInicial}
              alt="HaY Systems"
              style={{ objectFit: 'contain' }}
              className="w-full mb-3"
            />
            <span className="font-bold text-3xl text-primary">{this.traduzir('main.esquecisenha.titulo')}</span>
            <span className="text-500 text-sm mt-1">{this.traduzir('main.esquecisenha.subtitulo')}</span>
          </div>

          <Divider className="mt-4 mb-5" />

          {etapa === 'identificar' && (
            <>
              <div className="field mb-5" onKeyDown={e => this.handleKeyDown(e, () => this.avancarIdentificar())}>
                <ModelTextInput model={model.identificador} contexto={this} />
              </div>
              {erroGeral && <Message severity="error" text={erroGeral} className="w-full mb-4" style={{ justifyContent: 'flex-start' }} />}
              <Button label={this.traduzir('main.esquecisenha.avancar')} icon="pi pi-arrow-right" loading={carregando} onClick={() => this.avancarIdentificar()} className="w-full" size="small" />
            </>
          )}

          {etapa === 'otp' && (
            <>
              <p className="text-500 text-sm text-center mb-4">
                {this.traduzir('main.esquecisenha.otp.ajuda')} <strong>{destino}</strong>
              </p>
              <div className="field mb-5" onKeyDown={e => this.handleKeyDown(e, () => this.avancarOtp())}>
                <ModelOtp model={model.codigo} contexto={this} length={tamanhoPin} semLabel />
              </div>
              {erroGeral && <Message severity="error" text={erroGeral} className="w-full mb-4" style={{ justifyContent: 'flex-start' }} />}
              <Button label={this.traduzir('main.esquecisenha.otp.confirmar')} icon="pi pi-check" loading={carregando} onClick={() => this.avancarOtp()} className="w-full mb-3" size="small" />
              <Button label={this.traduzir('main.esquecisenha.otp.reenviar')} link loading={carregando} onClick={() => this.enviarOtp()} className="w-full p-0" size="small" />
            </>
          )}

          {etapa === 'novaSenha' && (
            <>
              <div className="field mb-5">
                <ModelSenha model={model.novasenha} contexto={this} mostrarMetricas={true} />
              </div>
              <div className="field mb-5" onKeyDown={e => this.handleKeyDown(e, () => this.salvarNovaSenha())}>
                <ModelSenha model={model.novasenhaconf} contexto={this} mostrarMetricas={false} />
              </div>
              {erroGeral && <Message severity="error" text={erroGeral} className="w-full mb-4" style={{ justifyContent: 'flex-start' }} />}
              <Button label={this.traduzir('main.esquecisenha.novasenha.salvar')} icon="pi pi-lock" loading={carregando} onClick={() => this.salvarNovaSenha()} className="w-full" size="small" />
            </>
          )}

          {etapa === 'sucesso' && (
            <>
              <div className="flex flex-column align-items-center mb-4">
                <i className="pi pi-check-circle text-6xl text-primary mb-3" />
                <span className="font-bold text-xl">{this.traduzir('main.esquecisenha.sucesso.titulo')}</span>
              </div>
              <Button label={this.traduzir('main.esquecisenha.sucesso.entrar')} icon="pi pi-sign-in" onClick={() => this.props.navigate({ pathname: '/login' })} className="w-full" size="small" />
            </>
          )}

          {etapa !== 'sucesso' && (
            <div className="flex justify-content-center mt-4">
              <Button label={this.traduzir('main.esquecisenha.voltar')} link onClick={() => this.props.navigate({ pathname: '/login' })} className="p-0" size="small" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(EsqueciSenhaPage);
